import { until } from '@open-draft/until'
import pRetry, { AbortError } from 'p-retry'
import { getCacheBustedUrl } from '../CacheBuster'
import { PreloaderLogger } from './Preloader'

export type GameTextsJson = {
	[language: string]: {
		[key: string]: string
	}
}

export async function loadGameTexts(log: PreloaderLogger): Promise<GameTextsJson> {
	const textsUrl = getCacheBustedUrl('assets/texts.json')

	const run = async () => {
		const response = await fetch(textsUrl)

		// Abort retrying if the resource doesn't exist
		if (response.status === 404) {
			throw new AbortError('Game texts not found (404)')
		}

		// Abort for other client or server errors
		if (!response.ok) {
			throw new AbortError(`Failed to fetch game texts: ${response.status} ${response.statusText}`)
		}

		return response.json()
	}

	// Use pRetry with until for elegant error handling
	const result = await until(() =>
		pRetry(run, {
			retries: 3,
			onFailedAttempt: (error) => {
				log(
					'warn',
					'preloader',
					`attempt ${error.attemptNumber} failed to fetch game texts, ${error.retriesLeft} retries left.`
				)
			},
		})
	)

	if (result.error) {
		log('warn', 'preloader', 'failed to load game texts after multiple retries:', result.error)
		throw result.error // Re-throw to let the caller handle it
	}

	// Set the texts in the global game object
	window.game.texts = result.data

	return result.data
}
